import MarketCap from './marketCap';

export default MarketCap;
